import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {StorageSystemsActions} from '../store';
import {StorageSystemsSelectors} from '../store/selectors';

@Injectable()
export class StorageSystemsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadCustomerDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadCustomerDone() {

    return this.store.pipe(
      select(StorageSystemsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(StorageSystemsActions.ReadStorageSystems({}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
